import { IconProps } from '../icon';

export function Mobile2Icon(props: IconProps) {
  return (
    <svg
      width="62"
      height="89"
      viewBox="0 0 62 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M48.9909 4.91641H13.3982C8.48385 4.91641 4.5 8.90026 4.5 13.8146V76.1018C4.5 81.0162 8.48385 85 13.3982 85H48.9909C53.9052 85 57.8891 81.0162 57.8891 76.1018V13.8146C57.8891 8.90026 53.9052 4.91641 48.9909 4.91641Z"
        stroke="#2A2A2A"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.7451 9.36551H35.6433M31.1942 67.2037V67.2481"
        stroke="#2A2A2A"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Mobile2Icon;
